import { apiService } from '../api.service';
import { BASE_UAPI_URL } from '@/constants/commonStrings.constant';
import { AxiosRequestConfig } from 'axios';

const UserProfileService = (agentId?: number) => {
  const getUserTicketTypes = async (
    agentId: number,
    { onSuccess, onError }: { onSuccess?: Function; onError?: Function },
  ) => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/agenttickettypes?agentid=' + agentId,
      onSuccess,
      onError,
    });
  };

  const getAllUsers = async ({ onSuccess, onError }: { onSuccess?: Function; onError?: Function }) => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/users',
      onSuccess,
      onError,
    });
  };

  const getUserProfile = async (params: any, config?: Partial<AxiosRequestConfig>): Promise<any> => {
    const requestId = `getUserProfile_${Date.now()}`;
    const response = await apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/users/byid?agentid=' + agentId,
      data: params,
      ...config,
      id: requestId,
    });
    return response;
  };

  const resetPassword = async (params: any, config?: Partial<AxiosRequestConfig>): Promise<any> => {
    const requestId = `postCreateStatus_${Date.now()}`;
    const response = await apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/agent/resetpassword',
      data: params,
      ...config,
      id: requestId,
    });
    return response;
  };
  return {
    getUserTicketTypes,
    getAllUsers,
    getUserProfile,
    resetPassword,
  };
};

export default UserProfileService;
